import {toast} from 'react-toastify';
import {put, takeEvery, takeLatest, select} from 'redux-saga/effects';
import {
  createByocVirtualNumberApi,
  deleteByocVirtualNumberApi,
  findByocVirtualNumbersApi,
  getLocationOtterBrandsApi,
  searchActiveLocationsApi,
  updateByocVirtualNumberApi
} from 'helpers/services/api/byocVirtualNumbers';
import {
  CREATE_BYOC_VIRTUAL_NUMBER,
  CREATE_BYOC_VIRTUAL_NUMBER_FAILURE,
  CREATE_BYOC_VIRTUAL_NUMBER_SUCCESS,
  DELETE_BYOC_VIRTUAL_NUMBER,
  DELETE_BYOC_VIRTUAL_NUMBER_FAILURE,
  DELETE_BYOC_VIRTUAL_NUMBER_SUCCESS,
  GET_BYOC_VIRTUAL_NUMBERS,
  GET_BYOC_VIRTUAL_NUMBERS_FAILURE,
  GET_BYOC_VIRTUAL_NUMBERS_SUCCESS,
  GET_LOCATION_OTTER_BRANDS,
  GET_LOCATION_OTTER_BRANDS_FAILURE,
  GET_LOCATION_OTTER_BRANDS_SUCCESS,
  SEARCH_ACTIVE_LOCATIONS,
  SEARCH_ACTIVE_LOCATIONS_FAILURE,
  SEARCH_ACTIVE_LOCATIONS_SUCCESS,
  UPDATE_BYOC_VIRTUAL_NUMBER,
  UPDATE_BYOC_VIRTUAL_NUMBER_FAILURE,
  UPDATE_BYOC_VIRTUAL_NUMBER_SUCCESS
} from 'store/byocVirtualNumbers/action';

const getByocVirtualNumbersState = ({byocVirtualNumbersReducer}) =>
  byocVirtualNumbersReducer;

function* getByocVirtualNumbers({payload}) {
  try {
    const {
      paging: {pageSize}
    } = yield select(getByocVirtualNumbersState);

    const {data} = yield findByocVirtualNumbersApi({
      page: payload?.page ?? 0,
      pageSize,
      search: payload?.search || undefined
    });
    if (data) {
      yield put(GET_BYOC_VIRTUAL_NUMBERS_SUCCESS(data));
    }
  } catch (error) {
    yield put(GET_BYOC_VIRTUAL_NUMBERS_FAILURE());
    console.log('SAGA ERROR', error);
  }
}

function* refreshCurrentPage() {
  const {
    paging: {page},
    search
  } = yield select(getByocVirtualNumbersState);
  yield put(GET_BYOC_VIRTUAL_NUMBERS({page, search}));
}

function* createByocVirtualNumber({payload}) {
  try {
    const {locationId, brandId, brandName, onSuccess} = payload || {};
    const {data} = yield createByocVirtualNumberApi({
      locationId,
      brandId,
      brandName
    });
    if (data) {
      toast.success('BYOC virtual number created successfully');
      yield put(CREATE_BYOC_VIRTUAL_NUMBER_SUCCESS());
      yield refreshCurrentPage();
      if (typeof onSuccess === 'function') {
        onSuccess(data);
      }
    } else {
      yield put(CREATE_BYOC_VIRTUAL_NUMBER_FAILURE());
    }
  } catch (error) {
    yield put(CREATE_BYOC_VIRTUAL_NUMBER_FAILURE());
    console.log('SAGA ERROR', error);
  }
}

function* updateByocVirtualNumber({payload}) {
  try {
    const {id, locationId, brandId, brandName, onSuccess} = payload || {};
    const {data} = yield updateByocVirtualNumberApi(id, {
      locationId,
      brandId,
      brandName
    });
    if (data) {
      toast.success('BYOC virtual number updated successfully');
      yield put(UPDATE_BYOC_VIRTUAL_NUMBER_SUCCESS());
      yield refreshCurrentPage();
      if (typeof onSuccess === 'function') {
        onSuccess(data);
      }
    } else {
      yield put(UPDATE_BYOC_VIRTUAL_NUMBER_FAILURE());
    }
  } catch (error) {
    yield put(UPDATE_BYOC_VIRTUAL_NUMBER_FAILURE());
    console.log('SAGA ERROR', error);
  }
}

function* getLocationOtterBrands({payload}) {
  try {
    const locationId = payload?.locationId;
    if (!locationId) {
      yield put(GET_LOCATION_OTTER_BRANDS_FAILURE());
      return;
    }

    const {data} = yield getLocationOtterBrandsApi(locationId);
    if (data) {
      yield put(GET_LOCATION_OTTER_BRANDS_SUCCESS({...data, locationId}));
    } else {
      yield put(GET_LOCATION_OTTER_BRANDS_FAILURE());
    }
  } catch (error) {
    yield put(GET_LOCATION_OTTER_BRANDS_FAILURE());
    console.log('SAGA ERROR', error);
  }
}

function* deleteByocVirtualNumber({payload}) {
  try {
    const {id, onSuccess} = payload || {};
    const response = yield deleteByocVirtualNumberApi(id);
    if (response?.status === 200 || response?.status === 204) {
      toast.success('BYOC virtual number deleted successfully');
      yield put(DELETE_BYOC_VIRTUAL_NUMBER_SUCCESS());
      yield refreshCurrentPage();
      if (typeof onSuccess === 'function') {
        onSuccess();
      }
    } else {
      yield put(DELETE_BYOC_VIRTUAL_NUMBER_FAILURE());
    }
  } catch (error) {
    yield put(DELETE_BYOC_VIRTUAL_NUMBER_FAILURE());
    console.log('SAGA ERROR', error);
  }
}

function* searchActiveLocations({payload}) {
  try {
    const search = payload?.search?.trim();
    if (!search) {
      yield put(SEARCH_ACTIVE_LOCATIONS_SUCCESS([]));
      return;
    }

    const {data} = yield searchActiveLocationsApi(search);
    if (data) {
      yield put(SEARCH_ACTIVE_LOCATIONS_SUCCESS(data.docs ?? []));
    }
  } catch (error) {
    yield put(SEARCH_ACTIVE_LOCATIONS_FAILURE());
    console.log('SAGA ERROR', error);
  }
}

function* byocVirtualNumbersSaga() {
  yield takeEvery(GET_BYOC_VIRTUAL_NUMBERS, getByocVirtualNumbers);
  yield takeEvery(CREATE_BYOC_VIRTUAL_NUMBER, createByocVirtualNumber);
  yield takeEvery(UPDATE_BYOC_VIRTUAL_NUMBER, updateByocVirtualNumber);
  yield takeEvery(DELETE_BYOC_VIRTUAL_NUMBER, deleteByocVirtualNumber);
  yield takeLatest(SEARCH_ACTIVE_LOCATIONS, searchActiveLocations);
  yield takeLatest(GET_LOCATION_OTTER_BRANDS, getLocationOtterBrands);
}

export default byocVirtualNumbersSaga;
